// api.js
/**
 * Perform an API request with optional access token and token refreshing.
 *
 * This function makes an asynchronous API request using the provided URL and options. It allows for the inclusion
 * of an access token and refresh token in the headers, which is important for authenticated requests.
 * If a new access token is generated during the request due to token expiration, this function updates the tokens
 * and reissues the request with the updated tokens.
 *
 * @param {string} url - The URL for the API endpoint.
 * @param {object} options - Options for the API request (e.g., method, headers, body).
 * @param {boolean} requiredAccessToken - Indicates whether an access token is required for the request.
 * @returns {Promise<object>} - A Promise resolving to the API response or an error.
 * @throws Throws an error if any issue occurs during the API request or token management.
 */
// export async function apiRequest(url, options, requiredAccessToken = false) {
//   console.log("🚀 ~ apiRequest ~ url:", url)
//   console.log("🚀 ~ apiRequest ~ options:", options)
//   // fetch the  access token and refresh token
//   const authTokens = getAccessTokenAndRefreshToken();

//   // If an access token is required and tokens are available
//   if (requiredAccessToken && authTokens?.token) {
//     // Prepare headers with access token and refresh token
//     const headers = {
//       ...options.headers,
//       "access-token": authTokens?.token,
//       // "refresh-token": authTokens?.refreshToken,
//     };   
//     try {
//       // Make the initial API request
//       const response = await fetch(url, { ...options, headers });
//       const result = await handleResponse(response);
//       console.log("🚀 ~ apiRequest ~ result:", result)

//       // Check if a new access token was generated
//       if (result?.message?.toLowerCase().includes("new access token")) {
//         // Update tokens with the new access token
//         updateTokens(result?.accesstoken);

//         // Retrieve the updated tokens
//         const authTokens = getAccessTokenAndRefreshToken();

//         // Prepare headers with the updated tokens
//         const headers = {
//           ...options.headers,
//           "access-token": authTokens?.token,
//           // "refresh-token": authTokens?.refreshToken,
//         };
//         // Re-Hitthe API request with the updated tokens
//         return fetch(url, { ...options, headers }).then(handleResponse);
//       } else {
//         // Return the API response
//         return result;
//       }
//     } catch (error) {
//       throw error; //  error that occur during the API request or token management
//     }
//   }
//   // // If an access token is not required, or tokens are missing
//   else {
//     // Make a regular API request without including tokens
//     return fetch(url, options).then(handleResponse);
//   }
// }

export async function apiRequest(url, options = {}, requiredAccessToken = false) {

  const authTokens = getAccessTokenAndRefreshToken();

  const applyAuthHeaders = (headers = {}) => ({
    ...headers,
    "access-token": authTokens?.token,
    // "refresh-token": authTokens?.refreshToken, // Uncomment if needed
  });

  const makeRequest = async (headers) => {
    const finalOptions = {
      ...options,
      headers,
    };
    const response = await fetch(url, finalOptions);
    return handleResponse(response);
  };

  try {
    if (requiredAccessToken && authTokens?.token) {
      let headers = applyAuthHeaders(options.headers);
      let result = await makeRequest(headers);

      if (result?.message?.toLowerCase().includes("new access token")) {
        updateTokens(result?.accesstoken);
        const newAuthTokens = getAccessTokenAndRefreshToken();
        headers = applyAuthHeaders(options.headers);
        result = await makeRequest(headers);
      }

      return result;
    } else {
      return await makeRequest(options.headers || {});
    }
  } catch (error) {
    console.error("apiRequest error:", error);
    throw error;
  }
}


async function handleResponse(response) {
  const result = await response.json();
  return result;
}

function updateTokens(accessToken, refreshToken) {
  updateTokenInLocalStorage(accessToken, refreshToken);
}

function updateTokenInLocalStorage(accessToken, refreshToken = null) {
  if(localStorage.getItem("userToken") !== null){
  const userTokenFromLocalStorage = localStorage.getItem("userToken");
  if (userTokenFromLocalStorage) {
    const userToken = JSON.parse(userTokenFromLocalStorage);
    const updatedUserToken = {
      ...userToken,
      token: accessToken,
      // refreshToken: refreshToken || userToken?.refreshToken,
  };

    localStorage.setItem("userToken", JSON.stringify(updatedUserToken));
    }
  }

}

export function checkToken() {
  return localStorage.getItem("token");
}

// utility function to set the Bearer token

export function setToken(token) {
  localStorage.setItem("token", token);
}

// utility function to remove the Bearer token

export function removeToken() {
  localStorage.removeItem("token");
}

// utility function to get the Bearer token

export function getToken() {
  return localStorage.getItem("token");
}

// utility function to get the user id

export function getUserId() {
  return localStorage.getItem("userId");
}

// tokens.js
// export const getAccessTokenAndRefreshToken = () => {
//   const userTokenFromLocalStorage = localStorage.getItem('sessionToken');

//   if (userTokenFromLocalStorage) {
//     const { token } = JSON.parse(userTokenFromLocalStorage);
//     return { token };
//   }
// };

export const getAccessTokenAndRefreshToken = () => {
  const userTokenFromLocalStorage = localStorage.getItem('sessionToken');

  if (userTokenFromLocalStorage) {
    try {
      const { token } = JSON.parse(userTokenFromLocalStorage);
      return { token };
    } catch (err) {
      console.warn("Session token is not a valid JSON object.");
      return { token: userTokenFromLocalStorage };
    }
  }
  return null;
};

